module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_6_m2.7c6c08f0125703c19aea03519443eeed.png";